type ChatMessageRole = "user" | "bot";

type ChatMessage = {
  role: ChatMessageRole;
  content: string;
};

const chatMessage: ChatMessage = {
  role: "user",
  content: "",
};

export type { ChatMessage, ChatMessageRole };

export { chatMessage };
